var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ftie_page_obj!=null)?_c('gtc-ftie-page',{attrs:{"prop_ftie_page_obj":_vm.ftie_page_obj,"prop_user_sites":_vm.userSites,"prop_user":_vm.login_user_name,"prop_user_roles":_vm.userRoles}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5530d72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_FTIEPage.vue
// module id = null
// module chunks = 